import { Children } from 'react';
import PropTypes from 'prop-types';
import { SimpleShowLayout, useRecordContext } from 'react-admin';
import { Box } from '@mui/material';

export const DetailsSampleList = ({ children, record: recordProp, leading = null }) => {
    const recordFromContext = useRecordContext();
    const record = recordProp ?? recordFromContext;

    return (
        <SimpleShowLayout record={record}>
            <Box className='details-sample-list'>
                {leading}
                {Children.toArray(children).map((child, index) => (
                    <SimpleShowLayout key={child.key ?? index} record={record}>
                        {child}
                    </SimpleShowLayout>
                ))}
            </Box>
        </SimpleShowLayout>
    );
};

DetailsSampleList.propTypes = {
    children: PropTypes.node,
    record: PropTypes.object,
    leading: PropTypes.node,
};
